import { Component } from '@angular/core';
import { ConnectionService } from 'ng-connection-service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['../styles.scss','./app.component.scss']
})
export class AppComponent {
  title = 'gamedaymeals_web';
  status = 'ONLINE';
  isConnected = true;
  totalTime:any;

  constructor(
    private connectionService: ConnectionService,
    private toastrService: ToastrService
  ){
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = "ONLINE";
        this.totalTime = 0;
      }
      else {
        this.status = "OFFLINE";
        this.totalTime = 0;
        let x = setInterval(()=>{
          this.totalTime++;
          if(this.status == "ONLINE"){
            clearInterval(x);
          }
          if(this.totalTime>=60 && this.status=='OFFLINE'){
            this.toastrService.error('Connection Lost');
            clearInterval(x);
          }
        },1000)
      }
    })
  }
}
